import type { RouteRecordRaw } from "vue-router";
import { routes as tourRoutes } from "@/frontend/pages/tools/tours/routes";
import { FeatureFlagName } from "@/services/fyApi";

export const routes: RouteRecordRaw[] = [
  {
    path: "",
    name: "tools",
    component: () => import("@/frontend/pages/tools/index.vue"),
    meta: {
      title: "tools.index",
      backgroundImage: "bg-7",
    },
  },
  {
    path: "travel-times/",
    name: "travel-times",
    component: () => import("@/frontend/pages/tools/travel-times.vue"),
    meta: {
      title: "tools.travelTimes",
      backgroundImage: "bg-8",
    },
  },
  {
    path: "cargo-grids/",
    name: "cargo-grids",
    component: () => import("@/frontend/pages/tools/cargo-grids.vue"),
    meta: {
      title: "tools.cargoGrids",
      backgroundImage: "bg-7",
    },
  },
  {
    path: "plaque/",
    name: "plaque-tool",
    component: () => import("@/frontend/pages/tools/plaque.vue"),
    meta: {
      title: "tools.plaque",
      backgroundImage: "bg-7",
    },
  },
  {
    path: "trade-routes/",
    name: "trade-routes",
    component: () => import("@/frontend/pages/tools/trade-routes.vue"),
    meta: {
      title: "tools.tradeRoutes",
      backgroundImage: "bg-7",
    },
  },
  {
    path: "dressing-room/",
    name: "dressing-room",
    component: () => import("@/frontend/pages/tools/dressing-room.vue"),
    meta: {
      title: "tools.dressingRoom",
      backgroundImage: "bg-room",
      feature: FeatureFlagName.DRESSING_ROOM,
    },
  },
  {
    path: "paint-booth/",
    name: "paint-booth",
    component: () => import("@/frontend/pages/tools/paint-booth.vue"),
    meta: {
      title: "tools.paintBooth",
      backgroundImage: "bg-room",
      // The booth is the textured holo: without that flag it has nothing to
      // repaint.
      feature: [FeatureFlagName.PAINT_BOOTH, FeatureFlagName.HOLO_TEXTURED],
    },
  },
  {
    path: "tours/",
    component: () => import("@/frontend/pages/tools/tours.vue"),
    children: tourRoutes,
    redirect: { name: tourRoutes[0].name as string },
  },
];
